import React, { useState } from 'react';

const Register = ({ onBackToLogin }) => {
  const [form, setForm] = useState({ email: '', password: '', role: 'Contratista' });
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const res = await fetch('/api/register', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form),
    });
    const data = await res.json();
    setMessage(data.message);
    if (res.ok) {
      setTimeout(onBackToLogin, 2000);
    }
  };

  return (
    <div className="auth-container">
      <form onSubmit={handleSubmit} className="auth-form">
        <h2>Registro de Nuevo Usuario</h2>
        {message && <p>{message}</p>}
        <input type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} required />
        <input type="password" placeholder="Contraseña" value={form.password} onChange={(e) => setForm({...form, password: e.target.value})} required />
        <select value={form.role} onChange={(e) => setForm({...form, role: e.target.value})}>
          <option value="Contratista">Contratista</option>
          <option value="Concesionario">Concesionario</option>
        </select>
        <button type="submit">Registrarse</button>
        <p><button type="button" onClick={onBackToLogin} className="link-button">Volver al Login</button></p>
      </form>
    </div>
  );
};

export default Register;